'use strict';

module.exports = require('./is-implemented')()
	? Object.assign
	: require('./shim');



/*****************
 ** WEBPACK FOOTER
 ** /Users/dan/p/react-devtools/~/es5-ext/object/assign/index.js
 ** module id = 11
 ** module chunks = 0
 **/